export function chunkArray(array, size) {
	const source = Array.isArray(array) ? array : [];
	const chunked = [];
	let index = 0;

	while (index < source.length) {
		chunked.push(source.slice(index, size + index));
		index += size;
	}

	return chunked;
}

export function flatArray(array) {
	if (!Array.isArray(array)) {
		return [];
	}

	return array.reduce((result, item) => {
		if (Array.isArray(item)) {
			result.push(...item);
		} else {
			result.push(item);
		}

		return result;
	}, []);
}

export function pushArray(destArray, sourceArray = []) {
	const destination = Array.isArray(destArray) ? destArray : [];
	const source = Array.isArray(sourceArray) ? sourceArray : [];

	for (let i = 0; i < source.length; i++) {
		destination.push(source[i]);
	}

	return destination;
}
